import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderDetalleService } from 'src/app/service/orderdetalle/order-detalle.service';
import { OrderPagoService } from 'src/app/service/orderpago/order-pago.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';

@Component({
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss']
})
export class FilesComponent implements OnInit {
  idImagen:String;
  constructor(private usuarioService:UsuarioService,private utilService:UtilitarioService,private router:Router,private route:ActivatedRoute,
    private orderDetalleService:OrderDetalleService,private orderPagoService:OrderPagoService) { 
      this.idImagen=this.route.snapshot.params.idImage
      this.donwloadimagen(this.idImagen);
    }

  donwloadimagen(idImg){
    this.utilService.loading = true;
    this.orderDetalleService.obtenerImgDescarga(idImg).subscribe(
      response => {
        // console.log('Response recibida:', response);

        // Descarga exitosa - procesar el blob
        if (response.status === 200 && response.body) {
          const blob = response.body;

          // Obtener el nombre del archivo desde el header Content-Disposition
          const contentDisposition = response.headers.get('Content-Disposition');
          let fileName = idImg + '.pdf'; // Nombre por defecto

          if (contentDisposition) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
              fileName = matches[1].replace(/['"]/g, '');
            }
          }

          // Crear URL del blob y descargar
          const url = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = fileName;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);

          // Liberar el objeto URL después de un delay
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 100);

          this.utilService.loading = false;
          this.router.navigate(['/']);
        } else {
          this.utilService.loading = false;
          console.error('Error al descargar el archivo.');
          this.router.navigate(['/']);
        }
      },
      error => {
        this.utilService.loading = false;
        console.error('Error en la descarga:', error);
        this.router.navigate(['/']);
      }
    );
  }

  ngOnInit(): void {
  }

}
